var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-0.45 -0.45 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.972 8.173h25.759a.99.99 0 0 0 .99-.99V4.706a.99.99 0 0 0-.99-.99H2.972a.99.99 0 0 0-.99.99v2.477c0 .547.443.99.99.99zm0 9.908h25.759a.99.99 0 0 0 .99-.991v-2.477a.99.99 0 0 0-.99-.99H2.972a.99.99 0 0 0-.99.99v2.477c0 .547.443.99.99.99zm0 9.907h25.759a.99.99 0 0 0 .99-.99V24.52a.99.99 0 0 0-.99-.99H2.972a.99.99 0 0 0-.99.99v2.477c0 .547.443.99.99.99z",
    id: "a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.1fe6fc6876dabef8fcf8f07259b6a938.svg";
export { ForwardRef as ReactComponent };